// src/constants/dcnCodeDictionary.js
// Complete DCN (Digital Convertible Note) Code Dictionary
// Organized by tier-based hierarchical classification system

/* ===============================
   YIELD RATE CODES (91xxxx)
   DCN Annual Yield Percentages
================================ */
export const YIELD_RATE_CODES = [
  {
    tier: '91',
    class: '9101',
    code: '910101',
    category: 'DCN Annual Yield',
    label: '1.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910102',
    category: 'DCN Annual Yield',
    label: '1.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910103',
    category: 'DCN Annual Yield',
    label: '1.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910104',
    category: 'DCN Annual Yield',
    label: '1.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910105',
    category: 'DCN Annual Yield',
    label: '2.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910106',
    category: 'DCN Annual Yield',
    label: '2.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910107',
    category: 'DCN Annual Yield',
    label: '2.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910108',
    category: 'DCN Annual Yield',
    label: '2.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910109',
    category: 'DCN Annual Yield',
    label: '3.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910110',
    category: 'DCN Annual Yield',
    label: '3.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910111',
    category: 'DCN Annual Yield',
    label: '3.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910112',
    category: 'DCN Annual Yield',
    label: '3.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910113',
    category: 'DCN Annual Yield',
    label: '4.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910114',
    category: 'DCN Annual Yield',
    label: '4.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910115',
    category: 'DCN Annual Yield',
    label: '4.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910116',
    category: 'DCN Annual Yield',
    label: '4.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910117',
    category: 'DCN Annual Yield',
    label: '5.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910118',
    category: 'DCN Annual Yield',
    label: '5.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910119',
    category: 'DCN Annual Yield',
    label: '5.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910120',
    category: 'DCN Annual Yield',
    label: '5.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910121',
    category: 'DCN Annual Yield',
    label: '6.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910122',
    category: 'DCN Annual Yield',
    label: '6.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910123',
    category: 'DCN Annual Yield',
    label: '6.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910124',
    category: 'DCN Annual Yield',
    label: '6.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910125',
    category: 'DCN Annual Yield',
    label: '7.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910126',
    category: 'DCN Annual Yield',
    label: '7.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910127',
    category: 'DCN Annual Yield',
    label: '7.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910128',
    category: 'DCN Annual Yield',
    label: '7.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910129',
    category: 'DCN Annual Yield',
    label: '8.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910130',
    category: 'DCN Annual Yield',
    label: '8.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910131',
    category: 'DCN Annual Yield',
    label: '8.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910132',
    category: 'DCN Annual Yield',
    label: '8.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910133',
    category: 'DCN Annual Yield',
    label: '9.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910134',
    category: 'DCN Annual Yield',
    label: '9.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910135',
    category: 'DCN Annual Yield',
    label: '9.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910136',
    category: 'DCN Annual Yield',
    label: '9.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910137',
    category: 'DCN Annual Yield',
    label: '10.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910138',
    category: 'DCN Annual Yield',
    label: '10.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910139',
    category: 'DCN Annual Yield',
    label: '10.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910140',
    category: 'DCN Annual Yield',
    label: '10.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910141',
    category: 'DCN Annual Yield',
    label: '11.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910142',
    category: 'DCN Annual Yield',
    label: '11.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910143',
    category: 'DCN Annual Yield',
    label: '11.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910144',
    category: 'DCN Annual Yield',
    label: '11.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910145',
    category: 'DCN Annual Yield',
    label: '12.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910146',
    category: 'DCN Annual Yield',
    label: '12.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910147',
    category: 'DCN Annual Yield',
    label: '12.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910148',
    category: 'DCN Annual Yield',
    label: '12.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910149',
    category: 'DCN Annual Yield',
    label: '13.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910150',
    category: 'DCN Annual Yield',
    label: '13.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910151',
    category: 'DCN Annual Yield',
    label: '13.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910152',
    category: 'DCN Annual Yield',
    label: '13.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910153',
    category: 'DCN Annual Yield',
    label: '14.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910154',
    category: 'DCN Annual Yield',
    label: '14.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910155',
    category: 'DCN Annual Yield',
    label: '14.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910156',
    category: 'DCN Annual Yield',
    label: '14.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910157',
    category: 'DCN Annual Yield',
    label: '15.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910158',
    category: 'DCN Annual Yield',
    label: '15.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910159',
    category: 'DCN Annual Yield',
    label: '15.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910160',
    category: 'DCN Annual Yield',
    label: '15.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910161',
    category: 'DCN Annual Yield',
    label: '16.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910162',
    category: 'DCN Annual Yield',
    label: '16.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910163',
    category: 'DCN Annual Yield',
    label: '16.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910164',
    category: 'DCN Annual Yield',
    label: '16.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910165',
    category: 'DCN Annual Yield',
    label: '17.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910166',
    category: 'DCN Annual Yield',
    label: '17.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910167',
    category: 'DCN Annual Yield',
    label: '17.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910168',
    category: 'DCN Annual Yield',
    label: '17.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910169',
    category: 'DCN Annual Yield',
    label: '18.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910170',
    category: 'DCN Annual Yield',
    label: '18.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910171',
    category: 'DCN Annual Yield',
    label: '18.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910172',
    category: 'DCN Annual Yield',
    label: '18.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910173',
    category: 'DCN Annual Yield',
    label: '19.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910174',
    category: 'DCN Annual Yield',
    label: '19.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910175',
    category: 'DCN Annual Yield',
    label: '19.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910176',
    category: 'DCN Annual Yield',
    label: '19.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910177',
    category: 'DCN Annual Yield',
    label: '20.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910178',
    category: 'DCN Annual Yield',
    label: '20.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910179',
    category: 'DCN Annual Yield',
    label: '20.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910180',
    category: 'DCN Annual Yield',
    label: '20.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910181',
    category: 'DCN Annual Yield',
    label: '21.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910182',
    category: 'DCN Annual Yield',
    label: '21.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910183',
    category: 'DCN Annual Yield',
    label: '21.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910184',
    category: 'DCN Annual Yield',
    label: '21.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910185',
    category: 'DCN Annual Yield',
    label: '22.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910186',
    category: 'DCN Annual Yield',
    label: '22.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910187',
    category: 'DCN Annual Yield',
    label: '22.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910188',
    category: 'DCN Annual Yield',
    label: '22.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910189',
    category: 'DCN Annual Yield',
    label: '23.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910190',
    category: 'DCN Annual Yield',
    label: '23.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910191',
    category: 'DCN Annual Yield',
    label: '23.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910192',
    category: 'DCN Annual Yield',
    label: '23.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910193',
    category: 'DCN Annual Yield',
    label: '24.00%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910194',
    category: 'DCN Annual Yield',
    label: '24.25%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910195',
    category: 'DCN Annual Yield',
    label: '24.50%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910196',
    category: 'DCN Annual Yield',
    label: '24.75%'
  },
  {
    tier: '91',
    class: '9101',
    code: '910197',
    category: 'DCN Annual Yield',
    label: '25.00%'
  }
];

/* ===============================
   SENIORITY CODES (92xxxx)
   DCN Capital Structure Position
================================ */
export const SENIORITY_CODES = [
  // Senior Secured Tier
  {
    tier: '92',
    class: '9201',
    code: '920101',
    category: 'Senior Secured Tier',
    subClass: 'First Lien',
    label: 'Senior Secured DCN (First Lien)'
  },
  {
    tier: '92',
    class: '9201',
    code: '920102',
    category: 'Senior Secured Tier',
    subClass: 'Second Lien',
    label: 'Senior Secured DCN (Second Lien)'
  },
  {
    tier: '92',
    class: '9201',
    code: '920103',
    category: 'Senior Secured Tier',
    subClass: 'Asset-Backed',
    label: 'Asset-Backed DCN'
  },
  {
    tier: '92',
    class: '9201',
    code: '920104',
    category: 'Senior Secured Tier',
    subClass: 'Collateralized',
    label: 'Collateralized DCN (Specific Asset)'
  },
  {
    tier: '92',
    class: '9201',
    code: '920105',
    category: 'Senior Secured Tier',
    subClass: 'Collateralized',
    label: 'Collateralized DCN (General Pool)'
  },

  // Senior Unsecured Tier
  {
    tier: '92',
    class: '9202',
    code: '920201',
    category: 'Senior Unsecured Tier',
    subClass: 'Senior Unsecured',
    label: 'Senior Unsecured DCN'
  },
  {
    tier: '92',
    class: '9202',
    code: '920202',
    category: 'Senior Unsecured Tier',
    subClass: 'Senior Priority',
    label: 'Senior Priority DCN'
  },
  {
    tier: '92',
    class: '9202',
    code: '920203',
    category: 'Senior Unsecured Tier',
    subClass: 'Senior Bullet',
    label: 'Senior Bullet DCN'
  },
  {
    tier: '92',
    class: '9202',
    code: '920204',
    category: 'Senior Unsecured Tier',
    subClass: 'Senior Fixed-Rate',
    label: 'Senior Fixed-Rate DCN'
  },
  {
    tier: '92',
    class: '9202',
    code: '920205',
    category: 'Senior Unsecured Tier',
    subClass: 'Senior Floating-Rate',
    label: 'Senior Floating-Rate DCN'
  },

  // Subordinated Tier
  {
    tier: '92',
    class: '9203',
    code: '920301',
    category: 'Subordinated Tier',
    subClass: 'Subordinated',
    label: 'Subordinated DCN'
  },
  {
    tier: '92',
    class: '9203',
    code: '920302',
    category: 'Subordinated Tier',
    subClass: 'Lower Tier Subordinated',
    label: 'Lower Tier Subordinated DCN'
  },
  {
    tier: '92',
    class: '9203',
    code: '920303',
    category: 'Subordinated Tier',
    subClass: 'Junior Subordinated',
    label: 'Junior Subordinated DCN'
  },
  {
    tier: '92',
    class: '9203',
    code: '920304',
    category: 'Subordinated Tier',
    subClass: 'Mezzanine',
    label: 'Mezzanine DCN'
  },

  // Hybrid / Convertible Tier
  {
    tier: '92',
    class: '9204',
    code: '920401',
    category: 'Hybrid / Convertible Tier',
    subClass: 'Convertible',
    label: 'Convertible DCN'
  },
  {
    tier: '92',
    class: '9204',
    code: '920402',
    category: 'Hybrid / Convertible Tier',
    subClass: 'Exchangeable',
    label: 'Exchangeable DCN'
  },
  {
    tier: '92',
    class: '9204',
    code: '920403',
    category: 'Hybrid / Convertible Tier',
    subClass: 'Contingent Convertible',
    label: 'Contingent Convertible DCN (CoCo)'
  },
  {
    tier: '92',
    class: '9204',
    code: '920404',
    category: 'Hybrid / Convertible Tier',
    subClass: 'Preferred-Linked',
    label: 'Preferred-Linked DCN'
  },
  {
    tier: '92',
    class: '9204',
    code: '920405',
    category: 'Hybrid / Convertible Tier',
    subClass: 'Equity-Linked',
    label: 'Equity-Linked DCN'
  },

  // Revenue-Based Tier
  {
    tier: '92',
    class: '9205',
    code: '920501',
    category: 'Revenue-Based Tier',
    subClass: 'Revenue-Share',
    label: 'Revenue-Share DCN'
  },
  {
    tier: '92',
    class: '9205',
    code: '920502',
    category: 'Revenue-Based Tier',
    subClass: 'Profit-Share',
    label: 'Profit-Share DCN'
  },
  {
    tier: '92',
    class: '9205',
    code: '920503',
    category: 'Revenue-Based Tier',
    subClass: 'Royalty-Based',
    label: 'Royalty-Based DCN'
  },
  {
    tier: '92',
    class: '9205',
    code: '920504',
    category: 'Revenue-Based Tier',
    subClass: 'Usage-Based',
    label: 'Usage-Based DCN'
  },
  {
    tier: '92',
    class: '9205',
    code: '920505',
    category: 'Revenue-Based Tier',
    subClass: 'Milestone-Triggered',
    label: 'Milestone-Triggered DCN'
  },

  // Junior / Residual Tier
  {
    tier: '92',
    class: '9206',
    code: '920601',
    category: 'Junior / Residual Tier',
    subClass: 'Junior',
    label: 'Junior DCN'
  },
  {
    tier: '92',
    class: '9206',
    code: '920602',
    category: 'Junior / Residual Tier',
    subClass: 'Residual Claim',
    label: 'Residual Claim DCN'
  },
  {
    tier: '92',
    class: '9206',
    code: '920603',
    category: 'Junior / Residual Tier',
    subClass: 'Equity-Participation',
    label: 'Equity-Participation DCN'
  },
  {
    tier: '92',
    class: '9206',
    code: '920604',
    category: 'Junior / Residual Tier',
    subClass: 'Last-Out',
    label: 'Last-Out DCN'
  }
];

/* ===============================
   REDEMPTION FREQUENCY (93xxxx)
   DCN Yield Token Redemption
================================ */
export const REDEMPTION_FREQUENCY_CODES = [
  // Periodic Redemption
  {
    tier: '93',
    class: '9301',
    code: '930101',
    category: 'DCN Yield Token Redemption',
    subClass: 'Periodic Redemption',
    label: 'Monthly Redemption'
  },
  {
    tier: '93',
    class: '9301',
    code: '930102',
    category: 'DCN Yield Token Redemption',
    subClass: 'Periodic Redemption',
    label: 'Quarterly Redemption'
  },
  {
    tier: '93',
    class: '9301',
    code: '930103',
    category: 'DCN Yield Token Redemption',
    subClass: 'Periodic Redemption',
    label: 'Semi-Annual Redemption'
  },
  {
    tier: '93',
    class: '9301',
    code: '930104',
    category: 'DCN Yield Token Redemption',
    subClass: 'Periodic Redemption',
    label: 'Annual Redemption'
  },

  // Event-Based Redemption
  {
    tier: '93',
    class: '9302',
    code: '930201',
    category: 'DCN Yield Token Redemption',
    subClass: 'Event-Based Redemption',
    label: 'Redemption at Maturity'
  },
  {
    tier: '93',
    class: '9302',
    code: '930202',
    category: 'DCN Yield Token Redemption',
    subClass: 'Event-Based Redemption',
    label: 'Redemption at Conversion'
  },
  {
    tier: '93',
    class: '9302',
    code: '930203',
    category: 'DCN Yield Token Redemption',
    subClass: 'Event-Based Redemption',
    label: 'Redemption at Liquidity Event'
  },
  {
    tier: '93',
    class: '9302',
    code: '930204',
    category: 'DCN Yield Token Redemption',
    subClass: 'Event-Based Redemption',
    label: 'Redemption at Collateral Release'
  },

  // Flexible Redemption
  {
    tier: '93',
    class: '9303',
    code: '930301',
    category: 'DCN Yield Token Redemption',
    subClass: 'Flexible Redemption',
    label: 'On-Demand Redemption'
  },
  {
    tier: '93',
    class: '9303',
    code: '930302',
    category: 'DCN Yield Token Redemption',
    subClass: 'Flexible Redemption',
    label: 'Rolling Redemption Window'
  },
  {
    tier: '93',
    class: '9303',
    code: '930303',
    category: 'DCN Yield Token Redemption',
    subClass: 'Flexible Redemption',
    label: 'Smart-Contract Triggered Redemption'
  }
];

/* ===============================
   YIELD TYPES (95xxxx)
   DCN Yield Calculation Methods
================================ */
export const YIELD_TYPE_CODES = [
  // Standard DCN Yields
  {
    tier: '95',
    class: '9501',
    code: '950101',
    category: 'Standard DCN Yields',
    subClass: 'Yield to Maturity',
    label: 'Yield to Maturity (YTM)'
  },
  {
    tier: '95',
    class: '9501',
    code: '950102',
    category: 'Standard DCN Yields',
    subClass: 'Yield to Call',
    label: 'Yield to Call (YTC)'
  },
  {
    tier: '95',
    class: '9501',
    code: '950103',
    category: 'Standard DCN Yields',
    subClass: 'Yield to Worst',
    label: 'Yield to Worst (YTW)'
  },
  {
    tier: '95',
    class: '9501',
    code: '950104',
    category: 'Standard DCN Yields',
    subClass: 'Yield to Put',
    label: 'Yield to Put (YTP)'
  },
  {
    tier: '95',
    class: '9501',
    code: '950105',
    category: 'Standard DCN Yields',
    subClass: 'Yield to Exercise',
    label: 'Yield to Exercise (YTE)'
  },
  {
    tier: '95',
    class: '9501',
    code: '950106',
    category: 'Standard DCN Yields',
    subClass: 'Current Yield',
    label: 'Current Yield'
  },

  // DCN-Specific Yields
  {
    tier: '95',
    class: '9502',
    code: '950201',
    category: 'DCN-Specific Yields',
    subClass: 'Yield to Conversion',
    label: 'Yield to Conversion (YTCV)'
  },
  {
    tier: '95',
    class: '9502',
    code: '950202',
    category: 'DCN-Specific Yields',
    subClass: 'Yield to Tokenization',
    label: 'Yield to Tokenization (YTT)'
  },
  {
    tier: '95',
    class: '9502',
    code: '950203',
    category: 'DCN-Specific Yields',
    subClass: 'Yield to Digital Redemption',
    label: 'Yield to Digital Redemption (YTDR)'
  },
  {
    tier: '95',
    class: '9502',
    code: '950204',
    category: 'DCN-Specific Yields',
    subClass: 'Yield to Collateral Unlock',
    label: 'Yield to Collateral Unlock (YTCU)'
  },
  {
    tier: '95',
    class: '9502',
    code: '950205',
    category: 'DCN-Specific Yields',
    subClass: 'Yield to Liquidity Event',
    label: 'Yield to Liquidity Event (YTLE)'
  },

  // Structured Yields
  {
    tier: '95',
    class: '9503',
    code: '950301',
    category: 'Structured Yields',
    subClass: 'Contingent Yield',
    label: 'Contingent Yield'
  },
  {
    tier: '95',
    class: '9503',
    code: '950302',
    category: 'Structured Yields',
    subClass: 'Step-Up/Step-Down Yield',
    label: 'Step-Up/Step-Down Yield'
  },
  {
    tier: '95',
    class: '9503',
    code: '950303',
    category: 'Structured Yields',
    subClass: 'Range Accrual Yield',
    label: 'Range Accrual Yield'
  },
  {
    tier: '95',
    class: '9503',
    code: '950304',
    category: 'Structured Yields',
    subClass: 'Callable Yield',
    label: 'Callable Yield'
  },
  {
    tier: '95',
    class: '9503',
    code: '950305',
    category: 'Structured Yields',
    subClass: 'Puttable Yield',
    label: 'Puttable Yield'
  },

  // Variable Yields
  {
    tier: '95',
    class: '9504',
    code: '950401',
    category: 'Variable Yields',
    subClass: 'Floating Rate Yield',
    label: 'Floating Rate Yield'
  },
  {
    tier: '95',
    class: '9504',
    code: '950402',
    category: 'Variable Yields',
    subClass: 'Inverse Floating Yield',
    label: 'Inverse Floating Yield'
  },
  {
    tier: '95',
    class: '9504',
    code: '950403',
    category: 'Variable Yields',
    subClass: 'Indexed Yield',
    label: 'Indexed Yield'
  },
  {
    tier: '95',
    class: '9504',
    code: '950404',
    category: 'Variable Yields',
    subClass: 'Algorithmic Yield',
    label: 'Algorithmic Yield'
  },

  // Cashflow-Linked Yields
  {
    tier: '95',
    class: '9505',
    code: '950501',
    category: 'Cashflow-Linked Yields',
    subClass: 'Revenue-Share Yield',
    label: 'Revenue-Share Yield'
  },
  {
    tier: '95',
    class: '9505',
    code: '950502',
    category: 'Cashflow-Linked Yields',
    subClass: 'Profit-Share Yield',
    label: 'Profit-Share Yield'
  },
  {
    tier: '95',
    class: '9505',
    code: '950503',
    category: 'Cashflow-Linked Yields',
    subClass: 'Royalty Yield',
    label: 'Royalty Yield'
  },
  {
    tier: '95',
    class: '9505',
    code: '950504',
    category: 'Cashflow-Linked Yields',
    subClass: 'Usage-Based Yield',
    label: 'Usage-Based Yield'
  },

  // Distressed Yields
  {
    tier: '95',
    class: '9506',
    code: '950601',
    category: 'Distressed Yields',
    subClass: 'Yield to Recovery',
    label: 'Yield to Recovery (YTR)'
  },
  {
    tier: '95',
    class: '9506',
    code: '950602',
    category: 'Distressed Yields',
    subClass: 'Yield to Haircut',
    label: 'Yield to Haircut (YTH)'
  },
  {
    tier: '95',
    class: '9506',
    code: '950603',
    category: 'Distressed Yields',
    subClass: 'Yield to Liquidation',
    label: 'Yield to Liquidation (YTLQ)'
  }
];

/* ===============================
   MANDATORY HOLD PERIODS (96xxxx)
   DCN Transfer Restrictions
================================ */
export const MANDATORY_HOLD_CODES = [
  // Standard Time-Based Hold
  {
    tier: '96',
    class: '9601',
    code: '960101',
    category: 'Standard Time-Based Hold',
    subClass: 'Time-Based',
    label: '30-Day Mandatory Hold'
  },
  {
    tier: '96',
    class: '9601',
    code: '960102',
    category: 'Standard Time-Based Hold',
    subClass: 'Time-Based',
    label: '60-Day Mandatory Hold'
  },
  {
    tier: '96',
    class: '9601',
    code: '960103',
    category: 'Standard Time-Based Hold',
    subClass: 'Time-Based',
    label: '90-Day Mandatory Hold'
  },
  {
    tier: '96',
    class: '9601',
    code: '960104',
    category: 'Standard Time-Based Hold',
    subClass: 'Time-Based',
    label: '180-Day Mandatory Hold'
  },
  {
    tier: '96',
    class: '9601',
    code: '960105',
    category: 'Standard Time-Based Hold',
    subClass: 'Time-Based',
    label: '270-Day Mandatory Hold'
  },
  {
    tier: '96',
    class: '9601',
    code: '960106',
    category: 'Standard Time-Based Hold',
    subClass: 'Time-Based',
    label: '365-Day Mandatory Hold'
  },

  // Regulatory Hold Periods
  {
    tier: '96',
    class: '9602',
    code: '960201',
    category: 'Regulatory Hold Periods',
    subClass: 'Regulatory',
    label: 'Reg D Mandatory Hold Period'
  },
  {
    tier: '96',
    class: '9602',
    code: '960202',
    category: 'Regulatory Hold Periods',
    subClass: 'Regulatory',
    label: 'Reg S Mandatory Hold Period'
  },
  {
    tier: '96',
    class: '9602',
    code: '960203',
    category: 'Regulatory Hold Periods',
    subClass: 'Regulatory',
    label: 'Rule 144A Seasoning Hold Period'
  },
  {
    tier: '96',
    class: '9602',
    code: '960204',
    category: 'Regulatory Hold Periods',
    subClass: 'Regulatory',
    label: 'Restricted Security Hold Period (Rule 144)'
  },
  {
    tier: '96',
    class: '9602',
    code: '960205',
    category: 'Regulatory Hold Periods',
    subClass: 'Regulatory',
    label: 'Accredited-Investor Hold Period'
  },

  // Smart-Contract Hold Periods
  {
    tier: '96',
    class: '9603',
    code: '960301',
    category: 'Smart-Contract Hold Periods',
    subClass: 'Digital',
    label: 'Smart-Contract Lockup Period'
  },
  {
    tier: '96',
    class: '9603',
    code: '960302',
    category: 'Smart-Contract Hold Periods',
    subClass: 'Digital',
    label: 'Protocol-Defined Hold Period'
  },
  {
    tier: '96',
    class: '9603',
    code: '960303',
    category: 'Smart-Contract Hold Periods',
    subClass: 'Digital',
    label: 'Validator-Enforced Hold Period'
  },
  {
    tier: '96',
    class: '9603',
    code: '960304',
    category: 'Smart-Contract Hold Periods',
    subClass: 'Digital',
    label: 'Network-Governance Hold Period'
  },
  {
    tier: '96',
    class: '9603',
    code: '960305',
    category: 'Smart-Contract Hold Periods',
    subClass: 'Digital',
    label: 'Token-Generation Hold Period'
  },

  // Performance-Based Hold Periods
  {
    tier: '96',
    class: '9604',
    code: '960401',
    category: 'Performance-Based Hold Periods',
    subClass: 'Performance',
    label: 'Revenue-Threshold Hold Period'
  },
  {
    tier: '96',
    class: '9604',
    code: '960402',
    category: 'Performance-Based Hold Periods',
    subClass: 'Performance',
    label: 'Profit-Threshold Hold Period'
  },
  {
    tier: '96',
    class: '9604',
    code: '960403',
    category: 'Performance-Based Hold Periods',
    subClass: 'Performance',
    label: 'Milestone-Triggered Hold Period'
  },
  {
    tier: '96',
    class: '9604',
    code: '960404',
    category: 'Performance-Based Hold Periods',
    subClass: 'Performance',
    label: 'Usage-Based Hold Period'
  },

  // Collateral-Based Hold Periods
  {
    tier: '96',
    class: '9605',
    code: '960501',
    category: 'Collateral-Based Hold Periods',
    subClass: 'Collateral',
    label: 'Collateral-Coverage Hold Period'
  },
  {
    tier: '96',
    class: '9605',
    code: '960502',
    category: 'Collateral-Based Hold Periods',
    subClass: 'Collateral',
    label: 'Collateral-Release Hold Period'
  },
  {
    tier: '96',
    class: '9605',
    code: '960503',
    category: 'Collateral-Based Hold Periods',
    subClass: 'Collateral',
    label: 'Asset-Backed Hold Period'
  },
  {
    tier: '96',
    class: '9605',
    code: '960504',
    category: 'Collateral-Based Hold Periods',
    subClass: 'Collateral',
    label: 'Over-Collateralization Hold Period'
  },

  // Liquidity-Event Hold Periods
  {
    tier: '96',
    class: '9606',
    code: '960601',
    category: 'Liquidity-Event Hold Periods',
    subClass: 'Liquidity',
    label: 'Exchange-Listing Hold Period'
  },
  {
    tier: '96',
    class: '9606',
    code: '960602',
    category: 'Liquidity-Event Hold Periods',
    subClass: 'Liquidity',
    label: 'Buyback-Pool Activation Hold Period'
  },
  {
    tier: '96',
    class: '9606',
    code: '960603',
    category: 'Liquidity-Event Hold Periods',
    subClass: 'Liquidity',
    label: 'Secondary-Market Eligibility Hold Period'
  },
  {
    tier: '96',
    class: '9606',
    code: '960604',
    category: 'Liquidity-Event Hold Periods',
    subClass: 'Liquidity',
    label: 'Liquidity-Event Trigger Hold Period'
  },

  // Hybrid Hold Periods
  {
    tier: '96',
    class: '9607',
    code: '960701',
    category: 'Hybrid Hold Periods',
    subClass: 'Hybrid',
    label: 'Time + Performance Hybrid Hold Period'
  },
  {
    tier: '96',
    class: '9607',
    code: '960702',
    category: 'Hybrid Hold Periods',
    subClass: 'Hybrid',
    label: 'Time + Collateral Hybrid Hold Period'
  },
  {
    tier: '96',
    class: '9607',
    code: '960703',
    category: 'Hybrid Hold Periods',
    subClass: 'Hybrid',
    label: 'Regulatory + Smart-Contract Hybrid Hold Period'
  }
];

/* ===============================
   EARLY REDEMPTION (97xxxx)
   DCN Early Redemption Options
================================ */
export const EARLY_REDEMPTION_CODES = [
  // Standard Early Redemption
  {
    tier: '97',
    class: '9701',
    code: '970101',
    category: 'Standard Early Redemption',
    subClass: 'Issuer Call',
    label: 'Issuer Call (Early Redemption)'
  },
  {
    tier: '97',
    class: '9701',
    code: '970102',
    category: 'Standard Early Redemption',
    subClass: 'Investor Put',
    label: 'Investor Put (Early Redemption)'
  },
  {
    tier: '97',
    class: '9701',
    code: '970103',
    category: 'Standard Early Redemption',
    subClass: 'Make-Whole Call',
    label: 'Make-Whole Call Redemption'
  },
  {
    tier: '97',
    class: '9701',
    code: '970104',
    category: 'Standard Early Redemption',
    subClass: 'Par Call',
    label: 'Par Call Redemption'
  },
  {
    tier: '97',
    class: '9701',
    code: '970105',
    category: 'Standard Early Redemption',
    subClass: 'Premium Call',
    label: 'Premium Call Redemption'
  },
  {
    tier: '97',
    class: '9701',
    code: '970106',
    category: 'Standard Early Redemption',
    subClass: 'Sinking Fund',
    label: 'Sinking Fund Redemption'
  },

  // Digital Early Redemption
  {
    tier: '97',
    class: '9702',
    code: '970201',
    category: 'Digital Early Redemption',
    subClass: 'Smart-Contract Triggered',
    label: 'Smart-Contract Triggered Early Redemption'
  },
  {
    tier: '97',
    class: '9702',
    code: '970202',
    category: 'Digital Early Redemption',
    subClass: 'Digital Asset-Based',
    label: 'Digital Asset-Based Early Redemption'
  },
  {
    tier: '97',
    class: '9702',
    code: '970203',
    category: 'Digital Early Redemption',
    subClass: 'Collateral-Release',
    label: 'Collateral-Release Early Redemption'
  },
  {
    tier: '97',
    class: '9702',
    code: '970204',
    category: 'Digital Early Redemption',
    subClass: 'Liquidity-Event',
    label: 'Liquidity-Event Early Redemption'
  },
  {
    tier: '97',
    class: '9702',
    code: '970205',
    category: 'Digital Early Redemption',
    subClass: 'Token Conversion',
    label: 'Token Conversion Early Redemption'
  },
  {
    tier: '97',
    class: '9702',
    code: '970206',
    category: 'Digital Early Redemption',
    subClass: 'Protocol-Triggered',
    label: 'Protocol-Triggered Early Redemption'
  },

  // Performance-Based Early Redemption
  {
    tier: '97',
    class: '9703',
    code: '970301',
    category: 'Performance-Based Early Redemption',
    subClass: 'Revenue-Threshold',
    label: 'Revenue-Threshold Early Redemption'
  },
  {
    tier: '97',
    class: '9703',
    code: '970302',
    category: 'Performance-Based Early Redemption',
    subClass: 'Profit-Threshold',
    label: 'Profit-Threshold Early Redemption'
  },
  {
    tier: '97',
    class: '9703',
    code: '970303',
    category: 'Performance-Based Early Redemption',
    subClass: 'Usage-Based',
    label: 'Usage-Based Early Redemption'
  },
  {
    tier: '97',
    class: '9703',
    code: '970304',
    category: 'Performance-Based Early Redemption',
    subClass: 'Milestone-Triggered',
    label: 'Milestone-Triggered Early Redemption'
  },
  {
    tier: '97',
    class: '9703',
    code: '970305',
    category: 'Performance-Based Early Redemption',
    subClass: 'Royalty-Based',
    label: 'Royalty-Based Early Redemption'
  },

  // Credit-Event Early Redemption
  {
    tier: '97',
    class: '9704',
    code: '970401',
    category: 'Credit-Event Early Redemption',
    subClass: 'Credit Deterioration',
    label: 'Credit Deterioration Early Redemption'
  },
  {
    tier: '97',
    class: '9704',
    code: '970402',
    category: 'Credit-Event Early Redemption',
    subClass: 'Rating-Downgrade',
    label: 'Rating-Downgrade Early Redemption'
  },
  {
    tier: '97',
    class: '9704',
    code: '970403',
    category: 'Credit-Event Early Redemption',
    subClass: 'Covenant-Breach',
    label: 'Covenant-Breach Early Redemption'
  },
  {
    tier: '97',
    class: '9704',
    code: '970404',
    category: 'Credit-Event Early Redemption',
    subClass: 'Default-Event',
    label: 'Default-Event Early Redemption'
  },
  {
    tier: '97',
    class: '9704',
    code: '970405',
    category: 'Credit-Event Early Redemption',
    subClass: 'Restructuring-Event',
    label: 'Restructuring-Event Early Redemption'
  },

  // Market-Condition Early Redemption
  {
    tier: '97',
    class: '9705',
    code: '970501',
    category: 'Market-Condition Early Redemption',
    subClass: 'Market-Level Trigger',
    label: 'Market-Level Trigger Redemption'
  },
  {
    tier: '97',
    class: '9705',
    code: '970502',
    category: 'Market-Condition Early Redemption',
    subClass: 'Volatility-Trigger',
    label: 'Volatility-Trigger Redemption'
  },
  {
    tier: '97',
    class: '9705',
    code: '970503',
    category: 'Market-Condition Early Redemption',
    subClass: 'Index-Trigger',
    label: 'Index-Trigger Redemption'
  },
  {
    tier: '97',
    class: '9705',
    code: '970504',
    category: 'Market-Condition Early Redemption',
    subClass: 'FX-Trigger',
    label: 'FX-Trigger Redemption'
  },
  {
    tier: '97',
    class: '9705',
    code: '970505',
    category: 'Market-Condition Early Redemption',
    subClass: 'Commodity-Trigger',
    label: 'Commodity-Trigger Redemption'
  },

  // Time-Based Early Redemption
  {
    tier: '97',
    class: '9706',
    code: '970601',
    category: 'Time-Based Early Redemption',
    subClass: 'Lock-Up Period',
    label: 'Callable After Lock-Up Period'
  },
  {
    tier: '97',
    class: '9706',
    code: '970602',
    category: 'Time-Based Early Redemption',
    subClass: 'Vesting Period',
    label: 'Callable After Vesting Period'
  },
  {
    tier: '97',
    class: '9706',
    code: '970603',
    category: 'Time-Based Early Redemption',
    subClass: 'Anniversary Dates',
    label: 'Callable on Anniversary Dates'
  },
  {
    tier: '97',
    class: '9706',
    code: '970604',
    category: 'Time-Based Early Redemption',
    subClass: 'Rolling Windows',
    label: 'Callable on Rolling Windows'
  },

  // Hybrid Early Redemption
  {
    tier: '97',
    class: '9707',
    code: '970701',
    category: 'Hybrid Early Redemption',
    subClass: 'Call + Conversion',
    label: 'Call + Conversion Hybrid Redemption'
  },
  {
    tier: '97',
    class: '9707',
    code: '970702',
    category: 'Hybrid Early Redemption',
    subClass: 'Performance + Collateral',
    label: 'Performance + Collateral Hybrid Redemption'
  },
  {
    tier: '97',
    class: '9707',
    code: '970703',
    category: 'Hybrid Early Redemption',
    subClass: 'Liquidity + Market',
    label: 'Liquidity + Market Hybrid Redemption'
  }
];

/* ===============================
   YTM TYPES (98xxxx)
   Yield to Maturity Calculation Methods
================================ */
export const YTM_CODES = [
  // Core YTM Types
  {
    tier: '98',
    class: '9801',
    code: '980101',
    category: 'Core YTM Types',
    subClass: 'Standard YTM',
    label: 'Standard Yield to Maturity (YTM)'
  },
  {
    tier: '98',
    class: '9801',
    code: '980102',
    category: 'Core YTM Types',
    subClass: 'Street-Convention YTM',
    label: 'Street-Convention Yield to Maturity'
  },
  {
    tier: '98',
    class: '9801',
    code: '980103',
    category: 'Core YTM Types',
    subClass: 'True YTM',
    label: 'True Yield to Maturity'
  },
  {
    tier: '98',
    class: '9801',
    code: '980104',
    category: 'Core YTM Types',
    subClass: 'DCN-Equivalent YTM',
    label: 'DCN-Equivalent Yield to Maturity'
  },
  {
    tier: '98',
    class: '9801',
    code: '980105',
    category: 'Core YTM Types',
    subClass: 'Annualized YTM',
    label: 'Annualized Yield to Maturity'
  },
  {
    tier: '98',
    class: '9801',
    code: '980106',
    category: 'Core YTM Types',
    subClass: 'Semiannual YTM',
    label: 'Semiannual Yield to Maturity'
  },
  {
    tier: '98',
    class: '9801',
    code: '980107',
    category: 'Core YTM Types',
    subClass: 'Continuous-Compounding YTM',
    label: 'Continuous-Compounding Yield to Maturity'
  },

  // DCN-Specific YTM
  {
    tier: '98',
    class: '9802',
    code: '980201',
    category: 'DCN-Specific YTM',
    subClass: 'Digital Maturity',
    label: 'Yield to Digital Maturity (YTDM)'
  },
  {
    tier: '98',
    class: '9802',
    code: '980202',
    category: 'DCN-Specific YTM',
    subClass: 'Token Maturity',
    label: 'Yield to Token Maturity (YTTM)'
  },
  {
    tier: '98',
    class: '9802',
    code: '980203',
    category: 'DCN-Specific YTM',
    subClass: 'Smart-Contract Maturity',
    label: 'Yield to Smart-Contract Maturity (YTSCM)'
  },
  {
    tier: '98',
    class: '9802',
    code: '980204',
    category: 'DCN-Specific YTM',
    subClass: 'Collateral Maturity',
    label: 'Yield to Collateral Maturity (YTCM)'
  },
  {
    tier: '98',
    class: '9802',
    code: '980205',
    category: 'DCN-Specific YTM',
    subClass: 'Liquidity-Event Maturity',
    label: 'Yield to Liquidity-Event Maturity (YTLEM)'
  },

  // Optionality-Adjusted YTM
  {
    tier: '98',
    class: '9803',
    code: '980301',
    category: 'Optionality-Adjusted YTM',
    subClass: 'Call-Adjusted',
    label: 'Yield to Maturity (Call-Adjusted)'
  },
  {
    tier: '98',
    class: '9803',
    code: '980302',
    category: 'Optionality-Adjusted YTM',
    subClass: 'Put-Adjusted',
    label: 'Yield to Maturity (Put-Adjusted)'
  },
  {
    tier: '98',
    class: '9803',
    code: '980303',
    category: 'Optionality-Adjusted YTM',
    subClass: 'Worst-Case',
    label: 'Yield to Maturity (Worst-Case)'
  },
  {
    tier: '98',
    class: '9803',
    code: '980304',
    category: 'Optionality-Adjusted YTM',
    subClass: 'Best-Case',
    label: 'Yield to Maturity (Best-Case)'
  },

  // Curve-Bucketed YTM
  {
    tier: '98',
    class: '9804',
    code: '980401',
    category: 'Curve-Bucketed YTM',
    subClass: '1-Year',
    label: '1-Year Yield to Maturity'
  },
  {
    tier: '98',
    class: '9804',
    code: '980402',
    category: 'Curve-Bucketed YTM',
    subClass: '2-Year',
    label: '2-Year Yield to Maturity'
  },
  {
    tier: '98',
    class: '9804',
    code: '980403',
    category: 'Curve-Bucketed YTM',
    subClass: '3-Year',
    label: '3-Year Yield to Maturity'
  },
  {
    tier: '98',
    class: '9804',
    code: '980404',
    category: 'Curve-Bucketed YTM',
    subClass: '5-Year',
    label: '5-Year Yield to Maturity'
  },
  {
    tier: '98',
    class: '9804',
    code: '980405',
    category: 'Curve-Bucketed YTM',
    subClass: '7-Year',
    label: '7-Year Yield to Maturity'
  },
  {
    tier: '98',
    class: '9804',
    code: '980406',
    category: 'Curve-Bucketed YTM',
    subClass: '10-Year',
    label: '10-Year Yield to Maturity'
  },
  {
    tier: '98',
    class: '9804',
    code: '980407',
    category: 'Curve-Bucketed YTM',
    subClass: '20-Year',
    label: '20-Year Yield to Maturity'
  },
  {
    tier: '98',
    class: '9804',
    code: '980408',
    category: 'Curve-Bucketed YTM',
    subClass: '30-Year',
    label: '30-Year Yield to Maturity'
  },

  // Scenario-Based YTM
  {
    tier: '98',
    class: '9805',
    code: '980501',
    category: 'Scenario-Based YTM',
    subClass: 'Stressed',
    label: 'Stressed Yield to Maturity'
  },
  {
    tier: '98',
    class: '9805',
    code: '980502',
    category: 'Scenario-Based YTM',
    subClass: 'Recovery-Based',
    label: 'Recovery-Based Yield to Maturity'
  },
  {
    tier: '98',
    class: '9805',
    code: '980503',
    category: 'Scenario-Based YTM',
    subClass: 'Haircut-Adjusted',
    label: 'Haircut-Adjusted Yield to Maturity'
  },
  {
    tier: '98',
    class: '9805',
    code: '980504',
    category: 'Scenario-Based YTM',
    subClass: 'Liquidation-Scenario',
    label: 'Liquidation-Scenario Yield to Maturity'
  },
  {
    tier: '98',
    class: '9805',
    code: '980505',
    category: 'Scenario-Based YTM',
    subClass: 'Conversion-Scenario',
    label: 'Conversion-Scenario Yield to Maturity'
  },

  // Cashflow-Adjusted YTM
  {
    tier: '98',
    class: '9806',
    code: '980601',
    category: 'Cashflow-Adjusted YTM',
    subClass: 'Revenue-Linked',
    label: 'Revenue-Linked Yield to Maturity'
  },
  {
    tier: '98',
    class: '9806',
    code: '980602',
    category: 'Cashflow-Adjusted YTM',
    subClass: 'Profit-Linked',
    label: 'Profit-Linked Yield to Maturity'
  },
  {
    tier: '98',
    class: '9806',
    code: '980603',
    category: 'Cashflow-Adjusted YTM',
    subClass: 'Royalty-Linked',
    label: 'Royalty-Linked Yield to Maturity'
  },
  {
    tier: '98',
    class: '9806',
    code: '980604',
    category: 'Cashflow-Adjusted YTM',
    subClass: 'Usage-Linked',
    label: 'Usage-Linked Yield to Maturity'
  },

  // Hybrid YTM
  {
    tier: '98',
    class: '9807',
    code: '980701',
    category: 'Hybrid YTM',
    subClass: 'Convertible',
    label: 'Convertible Yield to Maturity'
  },
  {
    tier: '98',
    class: '9807',
    code: '980702',
    category: 'Hybrid YTM',
    subClass: 'Exchangeable',
    label: 'Exchangeable Yield to Maturity'
  },
  {
    tier: '98',
    class: '9807',
    code: '980703',
    category: 'Hybrid YTM',
    subClass: 'Contingent-Convertible',
    label: 'Contingent-Convertible (CoCo) Yield to Maturity'
  },
  {
    tier: '98',
    class: '9807',
    code: '980704',
    category: 'Hybrid YTM',
    subClass: 'Equity-Participation',
    label: 'Equity-Participation Yield to Maturity'
  }
];

/* ===============================
   CONVERSION TYPES (96-99xxxx)
   DCN Conversion Mechanisms
================================ */
export const CONVERSION_MECHANISM_CODES = [
  // Equity-Linked Conversions (96xxxx)
  {
    tier: '96',
    class: '9601',
    code: '960101',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Straight Debt-to-Equity Conversion'
  },
  {
    tier: '96',
    class: '9601',
    code: '960102',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Discounted Debt-to-Equity Swap'
  },
  {
    tier: '96',
    class: '9601',
    code: '960103',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Premium Equity Conversion'
  },
  {
    tier: '96',
    class: '9601',
    code: '960104',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Mandatory Equity Conversion'
  },
  {
    tier: '96',
    class: '9601',
    code: '960105',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Optional Equity Conversion'
  },
  {
    tier: '96',
    class: '9601',
    code: '960106',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Contingent Equity Conversion'
  },
  {
    tier: '96',
    class: '9601',
    code: '960107',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Performance-Based Equity Conversion'
  },
  {
    tier: '96',
    class: '9601',
    code: '960108',
    category: 'Equity-Linked Conversions',
    subClass: 'Debt to Equity',
    label: 'Equity-Linked Conversion with Warrants or Rights'
  },

  // Token-Linked Conversions (97xxxx)
  {
    tier: '97',
    class: '9701',
    code: '970101',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-Utility Token Conversion'
  },
  {
    tier: '97',
    class: '9701',
    code: '970102',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-Security Token Conversion'
  },
  {
    tier: '97',
    class: '9701',
    code: '970103',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-Stable Token Conversion'
  },
  {
    tier: '97',
    class: '9701',
    code: '970104',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-Governance Token Conversion'
  },
  {
    tier: '97',
    class: '9701',
    code: '970105',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-Yield Token Conversion'
  },
  {
    tier: '97',
    class: '9701',
    code: '970106',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-Collateralized Token Conversion'
  },
  {
    tier: '97',
    class: '9701',
    code: '970107',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-Basket Token Conversion (DBT)'
  },
  {
    tier: '97',
    class: '9701',
    code: '970108',
    category: 'Token-Linked Conversions',
    subClass: 'Debt to Token',
    label: 'Debt-to-DCN Conversion'
  },

  // Debt-to-Debt Conversions (98xxxx)
  {
    tier: '98',
    class: '9801',
    code: '980101',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'Refinancing Conversion'
  },
  {
    tier: '98',
    class: '9801',
    code: '980102',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'Maturity Extension Conversion'
  },
  {
    tier: '98',
    class: '9801',
    code: '980103',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'Interest-Rate Conversion'
  },
  {
    tier: '98',
    class: '9801',
    code: '980104',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'Subordination Conversion'
  },
  {
    tier: '98',
    class: '9801',
    code: '980105',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'Secured-Unsecured Conversion'
  },
  {
    tier: '98',
    class: '9801',
    code: '980106',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'Convertible Debt Replacement'
  },
  {
    tier: '98',
    class: '9801',
    code: '980107',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'PIK Conversion'
  },
  {
    tier: '98',
    class: '9801',
    code: '980108',
    category: 'Debt-to-Debt Conversions',
    subClass: 'Debt to Debt',
    label: 'Zero-Coupon Conversion'
  },

  // Asset Conversions (99xxxx)
  {
    tier: '99',
    class: '9901',
    code: '990101',
    category: 'Asset Conversions',
    subClass: 'Debt to Asset',
    label: 'Debt-for-Real-Estate Swap'
  },
  {
    tier: '99',
    class: '9901',
    code: '990102',
    category: 'Asset Conversions',
    subClass: 'Debt to Asset',
    label: 'Debt-for-Equipment Swap'
  },
  {
    tier: '99',
    class: '9901',
    code: '990103',
    category: 'Asset Conversions',
    subClass: 'Debt to Asset',
    label: 'Debt-for-Inventory Swap'
  },
  {
    tier: '99',
    class: '9901',
    code: '990104',
    category: 'Asset Conversions',
    subClass: 'Debt to Asset',
    label: 'Debt-for-Receivables Swap'
  },
  {
    tier: '99',
    class: '9901',
    code: '990105',
    category: 'Asset Conversions',
    subClass: 'Debt to Asset',
    label: 'Debt-for-IP or Licensing Rights'
  },
  {
    tier: '99',
    class: '9901',
    code: '990106',
    category: 'Asset Conversions',
    subClass: 'Debt to Asset',
    label: 'Debt-for-Royalty Streams'
  },

  // Cashflow Conversions (99xxxx)
  {
    tier: '99',
    class: '9902',
    code: '990201',
    category: 'Cashflow Conversions',
    subClass: 'Debt to Cashflow',
    label: 'Revenue-Share Conversion'
  },
  {
    tier: '99',
    class: '9902',
    code: '990202',
    category: 'Cashflow Conversions',
    subClass: 'Debt to Cashflow',
    label: 'Profit-Share Conversion'
  },
  {
    tier: '99',
    class: '9902',
    code: '990203',
    category: 'Cashflow Conversions',
    subClass: 'Debt to Cashflow',
    label: 'Royalty-Based Conversion'
  },
  {
    tier: '99',
    class: '9902',
    code: '990204',
    category: 'Cashflow Conversions',
    subClass: 'Debt to Cashflow',
    label: 'Gross-Receipts Conversion'
  },
  {
    tier: '99',
    class: '9902',
    code: '990205',
    category: 'Cashflow Conversions',
    subClass: 'Debt to Cashflow',
    label: 'Subscription-Revenue Conversion'
  },
  {
    tier: '99',
    class: '9902',
    code: '990206',
    category: 'Cashflow Conversions',
    subClass: 'Debt to Cashflow',
    label: 'Usage-Based Conversion'
  },

  // Hybrid Conversions (99xxxx)
  {
    tier: '99',
    class: '9903',
    code: '990301',
    category: 'Hybrid Conversions',
    subClass: 'Hybrid',
    label: 'Debt-to-Equity + Token Hybrid'
  },
  {
    tier: '99',
    class: '9903',
    code: '990302',
    category: 'Hybrid Conversions',
    subClass: 'Hybrid',
    label: 'Debt-to-Equity + Royalty Hybrid'
  },
  {
    tier: '99',
    class: '9903',
    code: '990303',
    category: 'Hybrid Conversions',
    subClass: 'Hybrid',
    label: 'Debt-to-Token + Revenue-Share Hybrid'
  },
  {
    tier: '99',
    class: '9903',
    code: '990304',
    category: 'Hybrid Conversions',
    subClass: 'Hybrid',
    label: 'Debt-to-Convertible-Token Hybrid'
  },
  {
    tier: '99',
    class: '9903',
    code: '990305',
    category: 'Hybrid Conversions',
    subClass: 'Hybrid',
    label: 'Debt-to-Preferred Equity Hybrid'
  },
  {
    tier: '99',
    class: '9903',
    code: '990306',
    category: 'Hybrid Conversions',
    subClass: 'Hybrid',
    label: 'Debt-to-SAFE Conversion'
  },

  // Distressed Conversions (99xxxx)
  {
    tier: '99',
    class: '9904',
    code: '990401',
    category: 'Distressed Conversions',
    subClass: 'Distressed',
    label: 'Distressed Debt-for-Equity Swap'
  },
  {
    tier: '99',
    class: '9904',
    code: '990402',
    category: 'Distressed Conversions',
    subClass: 'Distressed',
    label: 'Haircut Conversion'
  },
  {
    tier: '99',
    class: '9904',
    code: '990403',
    category: 'Distressed Conversions',
    subClass: 'Distressed',
    label: 'Maturity Push-Out Conversion'
  },
  {
    tier: '99',
    class: '9904',
    code: '990404',
    category: 'Distressed Conversions',
    subClass: 'Distressed',
    label: 'Cram-Down Conversion'
  },
  {
    tier: '99',
    class: '9904',
    code: '990405',
    category: 'Distressed Conversions',
    subClass: 'Distressed',
    label: 'Pre-Pack Conversion'
  },
  {
    tier: '99',
    class: '9904',
    code: '990406',
    category: 'Distressed Conversions',
    subClass: 'Distressed',
    label: 'Debt-to-Recovery Token Conversion'
  }
];

/* ===============================
   CONVERSION WINDOWS (99xxxx)
   DCN Conversion Timeframes
================================ */
export const CONVERSION_WINDOW_CODES = [
  {
    tier: '99',
    class: '9901',
    code: '990101',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '6-Month Conversion Window'
  },
  {
    tier: '99',
    class: '9901',
    code: '990102',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '12-Month Conversion Window'
  },
  {
    tier: '99',
    class: '9901',
    code: '990103',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '18-Month Conversion Window'
  },
  {
    tier: '99',
    class: '9901',
    code: '990104',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '24-Month Conversion Window'
  },
  {
    tier: '99',
    class: '9901',
    code: '990105',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '30-Month Conversion Window'
  },
  {
    tier: '99',
    class: '9901',
    code: '990106',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '36-Month Conversion Window'
  },
  {
    tier: '99',
    class: '9901',
    code: '990107',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '42-Month Conversion Window'
  },
  {
    tier: '99',
    class: '9901',
    code: '990108',
    category: 'DCN Conversion Timeframes',
    subClass: 'Standard Conversion Window',
    label: '48-Month Conversion Window'
  }
];

/* ===============================
   REFERENCE CODES
   Additional Classification Systems
================================ */

export const GRADE_REFERENCE_CODES = [
  // Prime DCN Grades → Ultra-Prime
  {
    tier: '90',
    class: '9010',
    code: '901010',
    category: 'Prime DCN Grades',
    subClass: 'Ultra-Prime',
    label: 'DCN-UP1'
  },
  {
    tier: '90',
    class: '9010',
    code: '901020',
    category: 'Prime DCN Grades',
    subClass: 'Ultra-Prime',
    label: 'DCN-UP2'
  },
  {
    tier: '90',
    class: '9010',
    code: '901030',
    category: 'Prime DCN Grades',
    subClass: 'Ultra-Prime',
    label: 'DCN-UP3'
  },

  // Prime DCN Grades → Prime
  {
    tier: '90',
    class: '9020',
    code: '902010',
    category: 'Prime DCN Grades',
    subClass: 'Prime',
    label: 'DCN-P1'
  },
  {
    tier: '90',
    class: '9020',
    code: '902020',
    category: 'Prime DCN Grades',
    subClass: 'Prime',
    label: 'DCN-P2'
  },
  {
    tier: '90',
    class: '9020',
    code: '902030',
    category: 'Prime DCN Grades',
    subClass: 'Prime',
    label: 'DCN-P3'
  },

  // Investment Grade DCNs → Upper Investment Grade
  {
    tier: '91',
    class: '9110',
    code: '911010',
    category: 'Investment Grade DCNs',
    subClass: 'Upper Investment Grade',
    label: 'DCN-IG1'
  },
  {
    tier: '91',
    class: '9110',
    code: '911020',
    category: 'Investment Grade DCNs',
    subClass: 'Upper Investment Grade',
    label: 'DCN-IG2'
  },
  {
    tier: '91',
    class: '9110',
    code: '911030',
    category: 'Investment Grade DCNs',
    subClass: 'Upper Investment Grade',
    label: 'DCN-IG3'
  },

  // Speculative Grade DCNs → Moderate Speculative
  {
    tier: '92',
    class: '9210',
    code: '921010',
    category: 'Speculative Grade DCNs',
    subClass: 'Moderate Speculative',
    label: 'DCN-SG1'
  },
  {
    tier: '92',
    class: '9210',
    code: '921020',
    category: 'Speculative Grade DCNs',
    subClass: 'Moderate Speculative',
    label: 'DCN-SG2'
  },
  {
    tier: '92',
    class: '9210',
    code: '921030',
    category: 'Speculative Grade DCNs',
    subClass: 'Moderate Speculative',
    label: 'DCN-SG3'
  },

  // Speculative Grade DCNs → High Speculative
  {
    tier: '92',
    class: '9220',
    code: '922010',
    category: 'Speculative Grade DCNs',
    subClass: 'High Speculative',
    label: 'DCN-HS1'
  },
  {
    tier: '92',
    class: '9220',
    code: '922020',
    category: 'Speculative Grade DCNs',
    subClass: 'High Speculative',
    label: 'DCN-HS2'
  },
  {
    tier: '92',
    class: '9220',
    code: '922030',
    category: 'Speculative Grade DCNs',
    subClass: 'High Speculative',
    label: 'DCN-HS3'
  },

  // Distressed DCNs → Severe Risk
  {
    tier: '93',
    class: '9310',
    code: '931010',
    category: 'Distressed DCNs',
    subClass: 'Severe Risk',
    label: 'DCN-DR1'
  },
  {
    tier: '93',
    class: '9310',
    code: '931020',
    category: 'Distressed DCNs',
    subClass: 'Severe Risk',
    label: 'DCN-DR2'
  },
  {
    tier: '93',
    class: '9310',
    code: '931030',
    category: 'Distressed DCNs',
    subClass: 'Severe Risk',
    label: 'DCN-DR3'
  },

  // Distressed DCNs → Critical Risk
  {
    tier: '93',
    class: '9320',
    code: '932010',
    category: 'Distressed DCNs',
    subClass: 'Critical Risk',
    label: 'DCN-CR1'
  },
  {
    tier: '93',
    class: '9320',
    code: '932020',
    category: 'Distressed DCNs',
    subClass: 'Critical Risk',
    label: 'DCN-CR2'
  },

  // Default Status
  {
    tier: '94',
    class: '9410',
    code: '941010',
    category: 'Default Status',
    subClass: 'Default',
    label: 'DCN-D'
  },
  {
    tier: '94',
    class: '9420',
    code: '942010',
    category: 'Default Status',
    subClass: 'Selective Default',
    label: 'DCN-SD'
  },

  // Internal DCN Assessment
  {
    tier: '95',
    class: '9510',
    code: '951010',
    category: 'Internal DCN Assessment',
    subClass: 'Internal Prime',
    label: 'DCN-IA1'
  },
  {
    tier: '95',
    class: '9520',
    code: '952010',
    category: 'Internal DCN Assessment',
    subClass: 'Internal Moderate',
    label: 'DCN-IA2'
  },
  {
    tier: '95',
    class: '9530',
    code: '953010',
    category: 'Internal DCN Assessment',
    subClass: 'Internal Weak',
    label: 'DCN-IA3'
  }
];

// Exemption Types
export const EXEMPTION_REFERENCE_CODES = [
  {
    tier: '94',
    class: '9401',
    code: '940101',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation D Rule 506(b)'
  },
  {
    tier: '94',
    class: '9401',
    code: '940102',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation D Rule 506(c)'
  },
  {
    tier: '94',
    class: '9401',
    code: '940103',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation S Offshore Offering'
  },
  {
    tier: '94',
    class: '9401',
    code: '940104',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation A+ Tier 1'
  },
  {
    tier: '94',
    class: '9401',
    code: '940105',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation A+ Tier 2'
  },
  {
    tier: '94',
    class: '9401',
    code: '940106',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation CF Crowdfunding'
  },
  {
    tier: '94',
    class: '9401',
    code: '940107',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Intrastate Offering Rule 147'
  },
  {
    tier: '94',
    class: '9401',
    code: '940108',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation D Rule 504 (504)'
  },
  {
    tier: '94',
    class: '9401',
    code: '940109',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Rule 144A (144)'
  },
  {
    tier: '94',
    class: '9401',
    code: '940110',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Regulation S (RGS)'
  },
  {
    tier: '94',
    class: '9401',
    code: '940111',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Registration Exemptions',
    label: 'Unrated (UR)'
  },

  {
    tier: '94',
    class: '9402',
    code: '940201',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Prospectus Exemptions',
    label: 'Exempt from Full Prospectus'
  },
  {
    tier: '94',
    class: '9402',
    code: '940202',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Prospectus Exemptions',
    label: 'Exempt from Prospectus Updates'
  },
  {
    tier: '94',
    class: '9402',
    code: '940203',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Prospectus Exemptions',
    label: 'Exempt from Offering Circular'
  },

  {
    tier: '94',
    class: '9403',
    code: '940301',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Reporting Exemptions',
    label: 'Exempt from Periodic Reporting'
  },
  {
    tier: '94',
    class: '9403',
    code: '940302',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Reporting Exemptions',
    label: 'Exempt from Annual Reporting'
  },
  {
    tier: '94',
    class: '9403',
    code: '940303',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Reporting Exemptions',
    label: 'Exempt from Quarterly Reporting'
  },
  {
    tier: '94',
    class: '9403',
    code: '940304',
    category: 'Regulatory Filing Exemptions',
    subClass: 'Reporting Exemptions',
    label: 'Exempt from Material Event Reporting'
  },

  {
    tier: '94',
    class: '9404',
    code: '940401',
    category: 'Trading & Market Exemptions',
    subClass: 'Exchange Listing Exemptions',
    label: 'Exempt from Minimum Float Requirements'
  },
  {
    tier: '94',
    class: '9404',
    code: '940402',
    category: 'Trading & Market Exemptions',
    subClass: 'Exchange Listing Exemptions',
    label: 'Exempt from Market-Maker Requirements'
  },
  {
    tier: '94',
    class: '9404',
    code: '940403',
    category: 'Trading & Market Exemptions',
    subClass: 'Exchange Listing Exemptions',
    label: 'Exempt from Liquidity Thresholds'
  },
  {
    tier: '94',
    class: '9404',
    code: '940404',
    category: 'Trading & Market Exemptions',
    subClass: 'Exchange Listing Exemptions',
    label: 'Exempt from Price-Stability Requirements'
  },

  {
    tier: '94',
    class: '9405',
    code: '940501',
    category: 'Trading & Market Exemptions',
    subClass: 'Trading Rule Exemptions',
    label: 'Exempt from Short-Sale Restrictions'
  },
  {
    tier: '94',
    class: '9405',
    code: '940502',
    category: 'Trading & Market Exemptions',
    subClass: 'Trading Rule Exemptions',
    label: 'Exempt from Circuit Breaker Rules'
  },
  {
    tier: '94',
    class: '9405',
    code: '940503',
    category: 'Trading & Market Exemptions',
    subClass: 'Trading Rule Exemptions',
    label: 'Exempt from Tick-Size Rules'
  },
  {
    tier: '94',
    class: '9405',
    code: '940504',
    category: 'Trading & Market Exemptions',
    subClass: 'Trading Rule Exemptions',
    label: 'Exempt from Settlement Cycle Requirements'
  },

  {
    tier: '94',
    class: '9406',
    code: '940601',
    category: 'Investor Qualification Exemptions',
    subClass: 'Accredited Investor Exemptions',
    label: 'Accredited Investor Not Required'
  },
  {
    tier: '94',
    class: '9406',
    code: '940602',
    category: 'Investor Qualification Exemptions',
    subClass: 'Accredited Investor Exemptions',
    label: 'Qualified Purchaser Not Required'
  },
  {
    tier: '94',
    class: '9406',
    code: '940603',
    category: 'Investor Qualification Exemptions',
    subClass: 'Accredited Investor Exemptions',
    label: 'Institutional Investor Not Required'
  },

  {
    tier: '94',
    class: '9407',
    code: '940701',
    category: 'Investor Qualification Exemptions',
    subClass: 'Suitability Exemptions',
    label: 'Suitability Questionnaire Not Required'
  },
  {
    tier: '94',
    class: '9407',
    code: '940702',
    category: 'Investor Qualification Exemptions',
    subClass: 'Suitability Exemptions',
    label: 'Risk Disclosure Acknowledgment Not Required'
  },

  {
    tier: '94',
    class: '9408',
    code: '940801',
    category: 'Tax & Withholding Exemptions',
    subClass: 'Tax Treatment Exemptions',
    label: 'Exempt from Capital Gains Tax'
  },
  {
    tier: '94',
    class: '9408',
    code: '940802',
    category: 'Tax & Withholding Exemptions',
    subClass: 'Tax Treatment Exemptions',
    label: 'Exempt from Withholding Tax'
  },
  {
    tier: '94',
    class: '9408',
    code: '940803',
    category: 'Tax & Withholding Exemptions',
    subClass: 'Tax Treatment Exemptions',
    label: 'Exempt from Transaction Tax'
  },
  {
    tier: '94',
    class: '9408',
    code: '940804',
    category: 'Tax & Withholding Exemptions',
    subClass: 'Tax Treatment Exemptions',
    label: 'Exempt from VAT or GST'
  },

  {
    tier: '94',
    class: '9409',
    code: '940901',
    category: 'Tax & Withholding Exemptions',
    subClass: 'Jurisdictional Tax Exemptions',
    label: 'Offshore Tax Exemption'
  },
  {
    tier: '94',
    class: '9409',
    code: '940902',
    category: 'Tax & Withholding Exemptions',
    subClass: 'Jurisdictional Tax Exemptions',
    label: 'Treaty-Based Tax Exemption'
  },
  {
    tier: '94',
    class: '9409',
    code: '940903',
    category: 'Tax & Withholding Exemptions',
    subClass: 'Jurisdictional Tax Exemptions',
    label: 'Sovereign Entity Tax Exemption'
  },

  {
    tier: '94',
    class: '9410',
    code: '941001',
    category: 'Issuer-Level Exemptions',
    subClass: 'Corporate Exemptions',
    label: 'Exempt from Financial Statement Audits'
  },
  {
    tier: '94',
    class: '9410',
    code: '941002',
    category: 'Issuer-Level Exemptions',
    subClass: 'Corporate Exemptions',
    label: 'Exempt from Governance Requirements'
  },
  {
    tier: '94',
    class: '9410',
    code: '941003',
    category: 'Issuer-Level Exemptions',
    subClass: 'Corporate Exemptions',
    label: 'Exempt from Board Approval Requirements'
  },

  {
    tier: '94',
    class: '9411',
    code: '941101',
    category: 'Issuer-Level Exemptions',
    subClass: 'Operational Exemptions',
    label: 'Exempt from KYC/AML Requirements'
  },
  {
    tier: '94',
    class: '9411',
    code: '941102',
    category: 'Issuer-Level Exemptions',
    subClass: 'Operational Exemptions',
    label: 'Exempt from Custody Requirements'
  },
  {
    tier: '94',
    class: '9411',
    code: '941103',
    category: 'Issuer-Level Exemptions',
    subClass: 'Operational Exemptions',
    label: 'Exempt from Collateral Requirements'
  },

  {
    tier: '94',
    class: '9412',
    code: '941201',
    category: 'Digital Asset Exemptions',
    subClass: 'Token Offering Exemptions',
    label: 'Exempt from Digital Asset Registration'
  },
  {
    tier: '94',
    class: '9412',
    code: '941202',
    category: 'Digital Asset Exemptions',
    subClass: 'Token Offering Exemptions',
    label: 'Exempt from Smart-Contract Audit'
  },
  {
    tier: '94',
    class: '9412',
    code: '941203',
    category: 'Digital Asset Exemptions',
    subClass: 'Token Offering Exemptions',
    label: 'Exempt from Token Classification Rules'
  },

  {
    tier: '94',
    class: '9413',
    code: '941301',
    category: 'Digital Asset Exemptions',
    subClass: 'Blockchain Compliance Exemptions',
    label: 'Exempt from On-Chain Reporting'
  },
  {
    tier: '94',
    class: '9413',
    code: '941302',
    category: 'Digital Asset Exemptions',
    subClass: 'Blockchain Compliance Exemptions',
    label: 'Exempt from On-Chain Transparency'
  },
  {
    tier: '94',
    class: '9413',
    code: '941303',
    category: 'Digital Asset Exemptions',
    subClass: 'Blockchain Compliance Exemptions',
    label: 'Exempt from Validator Disclosure'
  },

  {
    tier: '94',
    class: '9414',
    code: '941401',
    category: 'DCN-Specific Exemptions',
    subClass: 'DCN Issuance Exemptions',
    label: 'Exempt from DCN Credit Rating Requirement'
  },
  {
    tier: '94',
    class: '9414',
    code: '941402',
    category: 'DCN-Specific Exemptions',
    subClass: 'DCN Issuance Exemptions',
    label: 'Exempt from DCN Collateral Requirement'
  },
  {
    tier: '94',
    class: '9414',
    code: '941403',
    category: 'DCN-Specific Exemptions',
    subClass: 'DCN Issuance Exemptions',
    label: 'Exempt from DCN Conversion Disclosure'
  },
  {
    tier: '94',
    class: '9414',
    code: '941404',
    category: 'DCN-Specific Exemptions',
    subClass: 'DCN Issuance Exemptions',
    label: 'Exempt from DCN Yield Disclosure'
  },

  {
    tier: '94',
    class: '9415',
    code: '941501',
    category: 'DCN-Specific Exemptions',
    subClass: 'DCN Redemption/Conversion Exemptions',
    label: 'Exempt from Redemption Frequency Rules'
  },
  {
    tier: '94',
    class: '9415',
    code: '941502',
    category: 'DCN-Specific Exemptions',
    subClass: 'DCN Redemption/Conversion Exemptions',
    label: 'Exempt from Conversion Trigger Disclosure'
  },
  {
    tier: '94',
    class: '9415',
    code: '941503',
    category: 'DCN-Specific Exemptions',
    subClass: 'DCN Redemption/Conversion Exemptions',
    label: 'Exempt from Yield Token Distribution Rules'
  }
];

// Geographic Regions
export const REGION_REFERENCE_CODES = [
  {
    tier: '80',
    class: '8010',
    code: '801010',
    category: 'Americas',
    subClass: 'North America',
    label: 'United States & Canada'
  },
  {
    tier: '80',
    class: '8010',
    code: '801020',
    category: 'Americas',
    subClass: 'North America',
    label: 'Mexico & Central North America'
  },
  {
    tier: '80',
    class: '8020',
    code: '802010',
    category: 'Americas',
    subClass: 'Latin America',
    label: 'South America'
  },
  {
    tier: '80',
    class: '8020',
    code: '802020',
    category: 'Americas',
    subClass: 'Latin America',
    label: 'Central America & Caribbean'
  },

  {
    tier: '81',
    class: '8110',
    code: '811010',
    category: 'Europe',
    subClass: 'Western Europe',
    label: 'Eurozone'
  },
  {
    tier: '81',
    class: '8110',
    code: '811020',
    category: 'Europe',
    subClass: 'Western Europe',
    label: 'Non-Eurozone West'
  },
  {
    tier: '81',
    class: '8120',
    code: '812010',
    category: 'Europe',
    subClass: 'Eastern Europe',
    label: 'EU East'
  },
  {
    tier: '81',
    class: '8120',
    code: '812020',
    category: 'Europe',
    subClass: 'Eastern Europe',
    label: 'Non-EU East'
  },

  {
    tier: '82',
    class: '8210',
    code: '821010',
    category: 'Middle East & Africa',
    subClass: 'Middle East',
    label: 'Gulf States'
  },
  {
    tier: '82',
    class: '8210',
    code: '821020',
    category: 'Middle East & Africa',
    subClass: 'Middle East',
    label: 'Levant'
  },
  {
    tier: '82',
    class: '8220',
    code: '822010',
    category: 'Middle East & Africa',
    subClass: 'Africa',
    label: 'North Africa'
  },
  {
    tier: '82',
    class: '8220',
    code: '822020',
    category: 'Middle East & Africa',
    subClass: 'Africa',
    label: 'Sub-Saharan Africa'
  },

  {
    tier: '83',
    class: '8310',
    code: '831010',
    category: 'Asia',
    subClass: 'East Asia',
    label: 'China Mainland'
  },
  {
    tier: '83',
    class: '8310',
    code: '831020',
    category: 'Asia',
    subClass: 'East Asia',
    label: 'Japan'
  },
  {
    tier: '83',
    class: '8310',
    code: '831030',
    category: 'Asia',
    subClass: 'East Asia',
    label: 'Korea & Taiwan'
  },
  {
    tier: '83',
    class: '8320',
    code: '832010',
    category: 'Asia',
    subClass: 'South Asia',
    label: 'India'
  },
  {
    tier: '83',
    class: '8320',
    code: '832020',
    category: 'Asia',
    subClass: 'South Asia',
    label: 'Pakistan Bangladesh Sri Lanka'
  },

  {
    tier: '84',
    class: '8410',
    code: '841010',
    category: 'Southeast Asia',
    subClass: 'ASEAN Core',
    label: 'Singapore Malaysia Thailand'
  },
  {
    tier: '84',
    class: '8410',
    code: '841020',
    category: 'Southeast Asia',
    subClass: 'ASEAN Core',
    label: 'Indonesia Philippines Vietnam'
  },
  {
    tier: '84',
    class: '8420',
    code: '842010',
    category: 'Southeast Asia',
    subClass: 'Frontier Southeast Asia',
    label: 'Cambodia Laos Myanmar'
  },

  {
    tier: '85',
    class: '8510',
    code: '851010',
    category: 'Oceania',
    subClass: 'Pacific Developed',
    label: 'Australia'
  },
  {
    tier: '85',
    class: '8510',
    code: '851020',
    category: 'Oceania',
    subClass: 'Pacific Developed',
    label: 'New Zealand'
  },
  {
    tier: '85',
    class: '8520',
    code: '852010',
    category: 'Oceania',
    subClass: 'Pacific Islands',
    label: 'Fiji Samoa Papua New Guinea'
  }
];

// Industry Sectors
export const SECTOR_REFERENCE_CODES = [
  {
    tier: '10',
    class: '1010',
    code: '101010',
    category: 'Energy',
    subClass: 'Energy Equipment & Services',
    label: 'Oil & Gas Services'
  },
  {
    tier: '10',
    class: '1020',
    code: '102010',
    category: 'Energy',
    subClass: 'Oil, Gas & Consumable Fuels',
    label: 'Integrated Oil & Gas'
  },
  {
    tier: '10',
    class: '1020',
    code: '102020',
    category: 'Energy',
    subClass: 'Oil, Gas & Consumable Fuels',
    label: 'Exploration & Production'
  },
  {
    tier: '10',
    class: '1020',
    code: '102030',
    category: 'Energy',
    subClass: 'Oil, Gas & Consumable Fuels',
    label: 'Coal & Consumable Fuels'
  },
  {
    tier: '10',
    class: '1020',
    code: '102040',
    category: 'Energy',
    subClass: 'Oil, Gas & Consumable Fuels',
    label: 'Renewable Energy Producers'
  },

  {
    tier: '15',
    class: '1510',
    code: '151010',
    category: 'Materials',
    subClass: 'Chemicals',
    label: 'Commodity Chemicals'
  },
  {
    tier: '15',
    class: '1510',
    code: '151020',
    category: 'Materials',
    subClass: 'Chemicals',
    label: 'Specialty Chemicals'
  },
  {
    tier: '15',
    class: '1520',
    code: '152010',
    category: 'Materials',
    subClass: 'Construction Materials',
    label: 'Cement & Aggregates'
  },
  {
    tier: '15',
    class: '1530',
    code: '153010',
    category: 'Materials',
    subClass: 'Metals & Mining',
    label: 'Precious Metals'
  },
  {
    tier: '15',
    class: '1530',
    code: '153020',
    category: 'Materials',
    subClass: 'Metals & Mining',
    label: 'Industrial Metals'
  },
  {
    tier: '15',
    class: '1530',
    code: '153030',
    category: 'Materials',
    subClass: 'Metals & Mining',
    label: 'Steel'
  },
  {
    tier: '15',
    class: '1540',
    code: '154010',
    category: 'Materials',
    subClass: 'Paper & Forest Products',
    label: 'Paper Packaging'
  },
  {
    tier: '15',
    class: '1540',
    code: '154020',
    category: 'Materials',
    subClass: 'Paper & Forest Products',
    label: 'Timber'
  },

  {
    tier: '20',
    class: '2010',
    code: '201010',
    category: 'Industrials',
    subClass: 'Capital Goods',
    label: 'Aerospace & Defense'
  },
  {
    tier: '20',
    class: '2010',
    code: '201020',
    category: 'Industrials',
    subClass: 'Capital Goods',
    label: 'Building Products'
  },
  {
    tier: '20',
    class: '2010',
    code: '201030',
    category: 'Industrials',
    subClass: 'Capital Goods',
    label: 'Electrical Equipment'
  },
  {
    tier: '20',
    class: '2010',
    code: '201040',
    category: 'Industrials',
    subClass: 'Capital Goods',
    label: 'Industrial Machinery'
  },
  {
    tier: '20',
    class: '2020',
    code: '202010',
    category: 'Industrials',
    subClass: 'Commercial & Professional Services',
    label: 'Consulting Services'
  },
  {
    tier: '20',
    class: '2020',
    code: '202020',
    category: 'Industrials',
    subClass: 'Commercial & Professional Services',
    label: 'Security & Alarm Services'
  },
  {
    tier: '20',
    class: '2030',
    code: '203010',
    category: 'Industrials',
    subClass: 'Transportation',
    label: 'Airlines'
  },
  {
    tier: '20',
    class: '2030',
    code: '203020',
    category: 'Industrials',
    subClass: 'Transportation',
    label: 'Marine Shipping'
  },
  {
    tier: '20',
    class: '2030',
    code: '203030',
    category: 'Industrials',
    subClass: 'Transportation',
    label: 'Railroads'
  },
  {
    tier: '20',
    class: '2030',
    code: '203040',
    category: 'Industrials',
    subClass: 'Transportation',
    label: 'Trucking & Logistics'
  },

  {
    tier: '25',
    class: '2510',
    code: '251010',
    category: 'Consumer Discretionary',
    subClass: 'Automobiles & Components',
    label: 'Auto Manufacturers'
  },
  {
    tier: '25',
    class: '2510',
    code: '251020',
    category: 'Consumer Discretionary',
    subClass: 'Automobiles & Components',
    label: 'Auto Parts'
  },
  {
    tier: '25',
    class: '2520',
    code: '252010',
    category: 'Consumer Discretionary',
    subClass: 'Consumer Durables',
    label: 'Homebuilding'
  },
  {
    tier: '25',
    class: '2520',
    code: '252020',
    category: 'Consumer Discretionary',
    subClass: 'Consumer Durables',
    label: 'Household Appliances'
  },
  {
    tier: '25',
    class: '2530',
    code: '253010',
    category: 'Consumer Discretionary',
    subClass: 'Consumer Services',
    label: 'Hotels Resorts & Cruise Lines'
  },
  {
    tier: '25',
    class: '2530',
    code: '253020',
    category: 'Consumer Discretionary',
    subClass: 'Consumer Services',
    label: 'Restaurants'
  },
  {
    tier: '25',
    class: '2530',
    code: '253030',
    category: 'Consumer Discretionary',
    subClass: 'Consumer Services',
    label: 'Leisure Facilities'
  },
  {
    tier: '25',
    class: '2540',
    code: '254010',
    category: 'Consumer Discretionary',
    subClass: 'Retailing',
    label: 'Specialty Retail'
  },
  {
    tier: '25',
    class: '2540',
    code: '254020',
    category: 'Consumer Discretionary',
    subClass: 'Retailing',
    label: 'Internet & Direct Marketing Retail'
  },

  {
    tier: '30',
    class: '3010',
    code: '301010',
    category: 'Consumer Staples',
    subClass: 'Food & Staples Retailing',
    label: 'Grocery & Supermarkets'
  },
  {
    tier: '30',
    class: '3020',
    code: '302010',
    category: 'Consumer Staples',
    subClass: 'Food Beverage & Tobacco',
    label: 'Packaged Foods'
  },
  {
    tier: '30',
    class: '3020',
    code: '302020',
    category: 'Consumer Staples',
    subClass: 'Food Beverage & Tobacco',
    label: 'Soft Drinks'
  },
  {
    tier: '30',
    class: '3020',
    code: '302030',
    category: 'Consumer Staples',
    subClass: 'Food Beverage & Tobacco',
    label: 'Alcoholic Beverages'
  },
  {
    tier: '30',
    class: '3020',
    code: '302040',
    category: 'Consumer Staples',
    subClass: 'Food Beverage & Tobacco',
    label: 'Tobacco'
  },
  {
    tier: '30',
    class: '3030',
    code: '303010',
    category: 'Consumer Staples',
    subClass: 'Household & Personal Products',
    label: 'Household Products'
  },
  {
    tier: '30',
    class: '3030',
    code: '303020',
    category: 'Consumer Staples',
    subClass: 'Household & Personal Products',
    label: 'Personal Care'
  },

  {
    tier: '35',
    class: '3510',
    code: '351010',
    category: 'Healthcare',
    subClass: 'Healthcare Equipment & Services',
    label: 'Healthcare Providers'
  },
  {
    tier: '35',
    class: '3510',
    code: '351020',
    category: 'Healthcare',
    subClass: 'Healthcare Equipment & Services',
    label: 'Medical Devices'
  },
  {
    tier: '35',
    class: '3520',
    code: '352010',
    category: 'Healthcare',
    subClass: 'Pharma Biotech & Life Sciences',
    label: 'Pharmaceuticals'
  },
  {
    tier: '35',
    class: '3520',
    code: '352020',
    category: 'Healthcare',
    subClass: 'Pharma Biotech & Life Sciences',
    label: 'Biotechnology'
  },
  {
    tier: '35',
    class: '3520',
    code: '352030',
    category: 'Healthcare',
    subClass: 'Pharma Biotech & Life Sciences',
    label: 'Life Sciences Tools'
  },

  {
    tier: '40',
    class: '4010',
    code: '401010',
    category: 'Financials',
    subClass: 'Banks',
    label: 'Diversified Banks'
  },
  {
    tier: '40',
    class: '4020',
    code: '402010',
    category: 'Financials',
    subClass: 'Financial Services',
    label: 'Asset Management'
  },
  {
    tier: '40',
    class: '4020',
    code: '402020',
    category: 'Financials',
    subClass: 'Financial Services',
    label: 'Investment Banking & Brokerage'
  },
  {
    tier: '40',
    class: '4020',
    code: '402030',
    category: 'Financials',
    subClass: 'Financial Services',
    label: 'Consumer Finance'
  },
  {
    tier: '40',
    class: '4030',
    code: '403010',
    category: 'Financials',
    subClass: 'Insurance',
    label: 'Life Insurance'
  },
  {
    tier: '40',
    class: '4030',
    code: '403020',
    category: 'Financials',
    subClass: 'Insurance',
    label: 'Property & Casualty Insurance'
  },

  {
    tier: '45',
    class: '4510',
    code: '451010',
    category: 'Real Estate',
    subClass: 'Equity REITs',
    label: 'Industrial REITs'
  },
  {
    tier: '45',
    class: '4510',
    code: '451020',
    category: 'Real Estate',
    subClass: 'Equity REITs',
    label: 'Retail REITs'
  },
  {
    tier: '45',
    class: '4510',
    code: '451030',
    category: 'Real Estate',
    subClass: 'Equity REITs',
    label: 'Residential REITs'
  },
  {
    tier: '45',
    class: '4520',
    code: '452010',
    category: 'Real Estate',
    subClass: 'Real Estate Management & Development',
    label: 'Real Estate Services'
  },

  {
    tier: '50',
    class: '5010',
    code: '501010',
    category: 'Information Technology',
    subClass: 'Software & Services',
    label: 'Application Software'
  },
  {
    tier: '50',
    class: '5010',
    code: '501020',
    category: 'Information Technology',
    subClass: 'Software & Services',
    label: 'Systems Software'
  },
  {
    tier: '50',
    class: '5010',
    code: '501030',
    category: 'Information Technology',
    subClass: 'Software & Services',
    label: 'IT Consulting'
  },
  {
    tier: '50',
    class: '5020',
    code: '502010',
    category: 'Information Technology',
    subClass: 'Technology Hardware',
    label: 'Communications Equipment'
  },
  {
    tier: '50',
    class: '5020',
    code: '502020',
    category: 'Information Technology',
    subClass: 'Technology Hardware',
    label: 'Computer Hardware'
  },
  {
    tier: '50',
    class: '5030',
    code: '503010',
    category: 'Information Technology',
    subClass: 'Semiconductors',
    label: 'Semiconductors'
  },
  {
    tier: '50',
    class: '5030',
    code: '503020',
    category: 'Information Technology',
    subClass: 'Semiconductors',
    label: 'Semiconductor Equipment'
  },

  {
    tier: '55',
    class: '5510',
    code: '551010',
    category: 'Communication Services',
    subClass: 'Media & Entertainment',
    label: 'Broadcasting'
  },
  {
    tier: '55',
    class: '5510',
    code: '551020',
    category: 'Communication Services',
    subClass: 'Media & Entertainment',
    label: 'Movies & Entertainment'
  },
  {
    tier: '55',
    class: '5510',
    code: '551030',
    category: 'Communication Services',
    subClass: 'Media & Entertainment',
    label: 'Interactive Media & Services'
  },
  {
    tier: '55',
    class: '5520',
    code: '552010',
    category: 'Communication Services',
    subClass: 'Telecom Services',
    label: 'Wireless Telecom'
  },
  {
    tier: '55',
    class: '5520',
    code: '552020',
    category: 'Communication Services',
    subClass: 'Telecom Services',
    label: 'Integrated Telecom'
  },

  {
    tier: '60',
    class: '6010',
    code: '601010',
    category: 'Utilities',
    subClass: 'Utilities',
    label: 'Electric Utilities'
  },
  {
    tier: '60',
    class: '6010',
    code: '601020',
    category: 'Utilities',
    subClass: 'Utilities',
    label: 'Gas Utilities'
  },
  {
    tier: '60',
    class: '6010',
    code: '601030',
    category: 'Utilities',
    subClass: 'Utilities',
    label: 'Water Utilities'
  },
  {
    tier: '60',
    class: '6010',
    code: '601040',
    category: 'Utilities',
    subClass: 'Utilities',
    label: 'Multi-Utilities'
  },

  {
    tier: '65',
    class: '6510',
    code: '651010',
    category: 'Emerging Industries',
    subClass: 'Technology Frontier',
    label: 'Artificial Intelligence'
  },
  {
    tier: '65',
    class: '6510',
    code: '651020',
    category: 'Emerging Industries',
    subClass: 'Technology Frontier',
    label: 'Blockchain & Digital Assets'
  },
  {
    tier: '65',
    class: '6510',
    code: '651030',
    category: 'Emerging Industries',
    subClass: 'Technology Frontier',
    label: 'Robotics & Automation'
  },
  {
    tier: '65',
    class: '6510',
    code: '651040',
    category: 'Emerging Industries',
    subClass: 'Technology Frontier',
    label: 'Space Technology'
  },
  {
    tier: '65',
    class: '6520',
    code: '652010',
    category: 'Emerging Industries',
    subClass: 'CleanTech',
    label: 'EV & Battery Tech'
  },
  {
    tier: '65',
    class: '6520',
    code: '652020',
    category: 'Emerging Industries',
    subClass: 'CleanTech',
    label: 'Renewable Energy Tech'
  }
];

// Reference Trading Symbols
// export const REFERENCE_SYMBOL_CODES = [
//   { code: 'NL0015001DQ7', label: 'NL0015001DQ7 – Euronext' },
//   { code: 'FR001400QOK5', label: 'FR001400QOK5 – Euronext' },
//   { code: 'PTOTEAOE0005', label: 'PTOTEAOE0005 – Euronext' },
//   { code: 'FR001400SCF6', label: 'FR001400SCF6 – Euronext' },
//   { code: 'B341', label: 'B341 – Euronext' },
//   { code: 'B331', label: 'B331 – Euronext' },
//   { code: 'B333', label: 'B333 – Euronext' },
//   { code: 'ETAND', label: 'ETAND – Euronext' },
//   { code: 'BOND', label: 'BOND – NYSE' },
//   { code: 'OTEW', label: 'OTEW – Euronext' },
//   { code: 'OTEL', label: 'OTEL – Euronext' },
//   { code: 'XS2783649176', label: 'XS2783649176 – Euronext' },
//   { code: 'BE0390219856', label: 'BE0390219856 – Euronext' },
//   { code: 'EDFBS', label: 'EDFBS – Euronext' },
//   { code: 'ETALX', label: 'ETALX – Euronext' },
//   { code: 'B352', label: 'B352 – Euronext' },
//   { code: 'ETANJ', label: 'ETANJ – Euronext' },
//   { code: 'AUTAN', label: 'AUTAN – Euronext' },
//   { code: 'ETAPV', label: 'ETAPV – Euronext' },
//   { code: 'USXM', label: 'USXM' }
// ];

export const REFERENCE_SYMBOL_CODES = [
  { code: 'NL0015001DQ7', label: 'NL0015001DQ7' },
  { code: 'FR001400QOK5', label: 'FR001400QOK5' },
  { code: 'PTOTEAOE0005', label: 'PTOTEAOE0005' },
  { code: 'FR001400SCF6', label: 'FR001400SCF6' },
  { code: 'B341', label: 'B341' },
  { code: 'B331', label: 'B331' },
  { code: 'B333', label: 'B333' },
  { code: 'ETAND', label: 'ETAND' },
  { code: 'BOND', label: 'BOND' },
  { code: 'OTEW', label: 'OTEW' },
  { code: 'OTEL', label: 'OTEL' },
  { code: 'XS2783649176', label: 'XS2783649176' },
  { code: 'BE0390219856', label: 'BE0390219856' },
  { code: 'EDFBS', label: 'EDFBS' },
  { code: 'ETALX', label: 'ETALX' },
  { code: 'B352', label: 'B352' },
  { code: 'ETANJ', label: 'ETANJ' },
  { code: 'AUTAN', label: 'AUTAN' },
  { code: 'ETAPV', label: 'ETAPV' },
  { code: 'USXM', label: 'USXM' }
];

/* ===============================
   HELPER FUNCTIONS
================================ */

/**
 * Get all codes by tier
 * @param {string} tier - Tier code (e.g., '91', '92', etc.)
 * @returns {Array} Array of codes for the specified tier
 */
export const getCodesByTier = (tier) => {
  const allCodes = [
    ...YIELD_RATE_CODES,
    ...SENIORITY_CODES,
    ...REDEMPTION_FREQUENCY_CODES,
    ...YIELD_TYPE_CODES,
    ...MANDATORY_HOLD_CODES,
    ...EARLY_REDEMPTION_CODES,
    ...YTM_CODES,
    ...CONVERSION_MECHANISM_CODES,
    ...CONVERSION_WINDOW_CODES
  ];

  return allCodes.filter((item) => item.tier === tier);
};

/**
 * Get code by exact code string
 * @param {string} code - Code string (e.g., '910101')
 * @returns {Object|null} Code object or null if not found
 */
export const getCodeByCode = (code) => {
  const allCodes = [
    ...YIELD_RATE_CODES,
    ...SENIORITY_CODES,
    ...REDEMPTION_FREQUENCY_CODES,
    ...YIELD_TYPE_CODES,
    ...MANDATORY_HOLD_CODES,
    ...EARLY_REDEMPTION_CODES,
    ...YTM_CODES,
    ...CONVERSION_MECHANISM_CODES,
    ...CONVERSION_WINDOW_CODES
  ];

  return allCodes.find((item) => item.code === code) || null;
};

/**
 * Get codes by category
 * @param {string} category - Category name
 * @returns {Array} Array of codes for the specified category
 */
export const getCodesByCategory = (category) => {
  const allCodes = [
    ...YIELD_RATE_CODES,
    ...SENIORITY_CODES,
    ...REDEMPTION_FREQUENCY_CODES,
    ...YIELD_TYPE_CODES,
    ...MANDATORY_HOLD_CODES,
    ...EARLY_REDEMPTION_CODES,
    ...YTM_CODES,
    ...CONVERSION_MECHANISM_CODES,
    ...CONVERSION_WINDOW_CODES
  ];

  return allCodes.filter((item) => item.category === category);
};

/**
 * Get all unique categories
 * @returns {Array} Array of unique category names
 */
export const getAllCategories = () => {
  const allCodes = [
    ...YIELD_RATE_CODES,
    ...SENIORITY_CODES,
    ...REDEMPTION_FREQUENCY_CODES,
    ...YIELD_TYPE_CODES,
    ...MANDATORY_HOLD_CODES,
    ...EARLY_REDEMPTION_CODES,
    ...YTM_CODES,
    ...CONVERSION_MECHANISM_CODES,
    ...CONVERSION_WINDOW_CODES
  ];

  return [...new Set(allCodes.map((item) => item.category))];
};

// Export all code arrays
export default {
  YIELD_RATE_CODES,
  SENIORITY_CODES,
  REDEMPTION_FREQUENCY_CODES,
  YIELD_TYPE_CODES,
  MANDATORY_HOLD_CODES,
  EARLY_REDEMPTION_CODES,
  YTM_CODES,
  CONVERSION_MECHANISM_CODES,
  CONVERSION_WINDOW_CODES,
  GRADE_REFERENCE_CODES,
  EXEMPTION_REFERENCE_CODES,
  REGION_REFERENCE_CODES,
  SECTOR_REFERENCE_CODES,
  REFERENCE_SYMBOL_CODES,
  getCodesByTier,
  getCodeByCode,
  getCodesByCategory,
  getAllCategories
};
